import Head from 'next/head';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { useCalendlyEventListener, InlineWidget } from 'react-calendly';

import Layout from '#layout/index';

const TimeAvailabilityProblems = dynamic(() =>
  import('../../app/pages/clase-gratis/time-availability-problems')
);

const getQueries = (queries, setUserData) => {
  setUserData({
    /* first_name: queries.first_name,
    last_name: queries.last_name,
    email: queries.email,
    phone: queries.phone,
    student_name: queries.student_name, */
    type: queries.type, // 5_to_7, 8_to_11, 12_plus
    course: queries.course, // 5_to_7, 8_to_11, 12_plus
    utm_source: queries.utm_source,
    utm_medium: queries.utm_medium
  });
};

const Reserva = () => {
  const router = useRouter();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    router.query.type && getQueries(router.query, setUserData);
  }, [router.query]);

  useCalendlyEventListener({
    onEventScheduled: e => {
      const query = { course: userData?.course };

      // Go to
      const pathname = '/clase-gratis/gracias';
      router.push({ pathname, query });
    }
  });

  return (
    <>
      <Head>
        <title>Clases de pruebas gratis | Crack The Code</title>
        <meta
          name="description"
          content="Academia de ciencia de la computación. Cursos y talleres de programación, robótica educativa, desarrollo de videojuegos y filmación para niños ¡Descubre nuestros cursos!"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Layout mainType="full_variant">
        <InlineWidget
          url={`https://calendly.com/${userData?.course}?hide_gdpr_banner=1`}
          pageSettings={{
            hideEventTypeDetails: false,
            hideLandingPageDetails: true,
            hideGdprBanner: true
          }}
          prefill={{ customAnswers: { a3: 'Web' } }}
          styles={{
            height: '840px',
            paddingTop: 90
          }}
        />
        <TimeAvailabilityProblems marginBottom={90} />
      </Layout>
    </>
  );
};

export default Reserva;
